import { useEffect } from 'react';
import { CustomerWebSiteAppInitResponse } from '@shory-health-individual/customer-api';
import { selectSetAppInit, useAppInitStore } from '../../../stores';

const useAppInit = (appInitResponse: CustomerWebSiteAppInitResponse) => {
	const setAppInit = useAppInitStore(selectSetAppInit);

	useEffect(() => {
		if (appInitResponse) {
			setAppInit(appInitResponse);
		}
	}, [appInitResponse]);
};

export default useAppInit;
